/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material';
import { renderNsirCodigo } from './tableCells';
import { resolveVencimentoBarColor } from './chartShared';

const VencimentoAlertsTable = ({ alerts, onAlertClick }) => {
  const theme = useTheme();

  if (!alerts?.length) {
    return (
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
        Nenhum alerta prioritário na janela
      </Typography>
    );
  }

  return (
    <TableContainer
      sx={{
        mt: 1,
        maxHeight: 120,
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
      }}
    >
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell sx={{ py: 0.5, fontSize: '0.6875rem', fontWeight: 700 }}>NSIR</TableCell>
            <TableCell sx={{ py: 0.5, fontSize: '0.6875rem', fontWeight: 700 }}>Urgência</TableCell>
            <TableCell sx={{ py: 0.5, fontSize: '0.6875rem', fontWeight: 700 }}>Malha</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {alerts.map((alert) => {
            const urgencyColor = resolveVencimentoBarColor(alert.bucket, theme);
            return (
              <TableRow
                key={alert.id ?? alert.codigo}
                hover
                onClick={() => onAlertClick?.(alert)}
                sx={{ cursor: onAlertClick ? 'pointer' : 'default' }}
              >
                <TableCell sx={{ py: 0.5, fontSize: '0.75rem' }}>
                  {renderNsirCodigo(alert)}
                </TableCell>
                <TableCell sx={{ py: 0.5, fontSize: '0.75rem' }}>
                  <Box component="span" sx={{ color: urgencyColor, fontWeight: 600 }}>
                    {alert.urgencyLabel || '—'}
                  </Box>
                </TableCell>
                <TableCell sx={{ py: 0.5, fontSize: '0.75rem' }} noWrap>
                  {alert.malhaNome || '—'}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

VencimentoAlertsTable.propTypes = {
  alerts: PropTypes.arrayOf(PropTypes.object),
  onAlertClick: PropTypes.func,
};

VencimentoAlertsTable.defaultProps = {
  alerts: [],
  onAlertClick: null,
};

export default VencimentoAlertsTable;
